import { persistentMap } from '@nanostores/persistent';

export type Framework =
  | 'react_tailwind'
  | 'react_chakra'
  | 'react_shadcn'
  | 'angular_css'
  | 'html_tailwind'
  | 'html_css'
  | 'flutter'
  | 'vue_tailwind'
  | 'reactnative';

export type Language = 'ts' | 'js' | 'dart';

export type AI_Model = 'dev-ai-model' | 'prod-ai-model' | 'dev-mock-ai-model';

export type SelectionValues = {
  framework: Framework;
  language: Language;
  projectName: string;
  temporaryProjectRules: string;
  githubAccessToken: string;
  netlifyAccessToken: string;
  netlifySiteId: string;
  netlifySiteUrl: string;
  aiModel: AI_Model;
};

export const selectionStore = persistentMap<SelectionValues>('selection', {
  framework: 'react_tailwind' as Framework,
  language: 'ts' as Language,
  projectName: 'Untitled',
  aiModel: 'dev-mock-ai-model',
  temporaryProjectRules: '',
  githubAccessToken: '',
  netlifyAccessToken: '',
  netlifySiteId: '',
  netlifySiteUrl: '',
});
